// Access Denied Component

export function renderAccessDenied() {
  return `
    <div class="access-denied">
      <div class="access-denied-icon">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
        </svg>
      </div>
      <h2>Zugriff verweigert</h2>
      <p>Sie haben keine Berechtigung, auf diese Seite zuzugreifen.</p>
      <p class="access-denied-hint">Diese Seite ist nur für Administratoren verfügbar.</p>
      <a href="#/" class="btn btn-primary">Zurück zur Startseite</a>
    </div>
  `;
}

export function initAccessDenied() {
  // No initialization needed for this static component
}
